const readString = (value) => (typeof value === 'string' ? value.trim() : '');

const CONTEXT_TOOLS = new Set(['create_os_branch', 'activate_os_branch', 'get_active_os_context']);
const REFRESH_TOOLS = new Set(['reset_os_branch', 'archive_os_branch', 'discard_os_branch_changes']);
const EXECUTION_TOOLS = new Set(['execute_code', 'run_program', 'get_code_execution_operation']);

/** Translate current OS Branch receipts into the shared chat/Build preview. */
export const extractSandboxUiActionFromToolResult = (toolName, result) => {
  const name = readString(toolName);
  if (!result || result.success !== true || ['failed', 'cancelled'].includes(result.status)) return null;

  if (name === 'switch_to_live' ||
      (name === 'archive_os_branch' && result.active_os_context?.kind === 'live')) {
    return { type: 'clear' };
  }

  if (CONTEXT_TOOLS.has(name) || name === 'commit_os_revision') {
    const context = result.active_os_context || {};
    if (context.kind === 'live') return { type: 'clear' };
    const branch = result.os_branch || {};
    const revision = result.revision || {};
    const branchId = readString(context.branch_id || branch.branch_id || revision.branch_id);
    if (!branchId) return null;
    return {
      type: 'activate',
      preview: {
        sandbox_id: branchId,
        active_overlay_id: readString(context.effective_overlay_id || revision.revision_id || branch.head_revision_id) || null,
        sandbox_name: readString(branch.name) || null,
      },
    };
  }

  if (name === 'publish_os_branch') {
    // Submitting an approval is successful too, but the draft is still active.
    if (result.dry_run === true) return null;
    return (result.sandbox_status || result.status) === 'published' || result.published === true
      ? { type: 'clear' }
      : { type: 'refresh' };
  }

  if (REFRESH_TOOLS.has(name)) return { type: 'refresh' };
  if (EXECUTION_TOOLS.has(name) && result.result?.staged_working_state?.staged === true) {
    return { type: 'refresh' };
  }
  return null;
};
